import { useWalmartDisabledPage } from 'pages/loyalty/loyalty-partners/walmart/use-walmart-disabled-redirect';
import { WalmartRedirect } from 'pages/loyalty/loyalty-partners/walmart/walmart-redirect';

export default function WalmartRedirectPage() {
  const disabledRedirect = useWalmartDisabledPage();
  if (disabledRedirect) {
    return disabledRedirect;
  }
  return <WalmartRedirect />;
}
